import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMailCheck = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.277 14.422v1.53c0 2.499-1.669 3.98-4.143 3.97H7.142C4.669 19.933 3 18.452 3 15.953V10.67c0-.481.122-.936.35-1.343.204-.367.488-.692.838-.936l5.567-3.875a2.4 2.4 0 0 1 2.767 0l2.393 1.661"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m3.354 9.328 5.916 4.769c1.115.88 2.686.88 3.793 0l.684-.553"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.69 6.095a4.312 4.312 0 1 1-.001 8.623 4.312 4.312 0 0 1 0-8.623"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15.455 9.598 1.475 1.477 3.039-3.04"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMailCheck);
export default ForwardRef;
